import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    ProductId,
    ProductWitholdingPeriodDays
} from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectProductWitholdingPeriodDays } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: ProductId;
}

interface ConnectedProps {
    productWitholdingPeriodDays: ProductWitholdingPeriodDays;
}

type Props = OwnProps & ConnectedProps;

export class ProductWitholdingPeriodDaysTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productWitholdingPeriodDays } = this.props;

        return <TableCell>{productWitholdingPeriodDays}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productWitholdingPeriodDays: makeSelectProductWitholdingPeriodDays()
});

export default connect(mapStateToProps)(
    ProductWitholdingPeriodDaysTableCellComponent
);
